import { makeStyles, tokens } from '@fluentui/react-components';

export const useClaimEventsDialogStyles = makeStyles({
  content: {
    whiteSpace: 'pre-line',
    paddingBottom: tokens.spacingVerticalL,
  },
});
